import { Pt, pt } from "./pt";

class Matrix {
  private buf: number[];

  constructor(values: number[]) {
    this.buf = values;
  }

  transform(pt1: Pt): Pt {
    return pt(
      pt1.x * this.buf[0] + pt1.y * this.buf[1] + this.buf[2],
      pt1.x * this.buf[3] + pt1.y * this.buf[4] + this.buf[5]
    );
  }

  mul(m: Matrix): Matrix {
    var elements = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    for (var i = 0; i < 3; i++) {
      for (var j = 0; j < 3; j++) {
        var n = 0;
        for (var k = 0; k < 3; k++) {
          n += m.get(k, j) * this.get(i, k);
        }
        elements[i * 3 + j] = n;
      }
    }
    return new Matrix(elements);
  }

  get(row: number, col: number): number {
    return this.buf[row * 3 + col];
  }

  static scale(x: number, y: number): Matrix {
    return new Matrix([x, 0, 0, 0, y, 0, 0, 0, 1]);
  }

  static rotate(radians: number): Matrix {
    const c = Math.cos(radians);
    const s = Math.sin(radians);
    return new Matrix([c, -s, 0, s, c, 0, 0, 0, 1]);
  }

  static translate(x: number, y: number): Matrix {
    return new Matrix([1, 0, x, 0, 1, y, 0, 0, 1]);
  }
}

export { Matrix };
